import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledMuiButton = styled(Button)`
  background-color: #0042b0;
  color: #ffffff;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  border-radius: 8px;

  min-height: 47px;
  padding: 6px 24px;

  &:hover {
    background-color: #ffffff;
    outline: 1px solid #0042b0;
    color: #0042b0;
  }
`;
